import { dlog } from "@shared/utility.js";
import { notificationCenter } from "@shared/NotificationCenter.js";
import { Notifications } from "@shared/Notifications.js";

class PriceLookup {
    constructor() {
        this.priceMap = new Map();
        this.priceEndpointCallback = null;
    }

    setPriceEndpoint(callback) {
        this.priceEndpointCallback = callback;
    }

    async fetchPrices(skus) {
        if (!this.priceEndpointCallback || !skus || skus.length === 0) {
            console.error("PriceLookup: No price endpoint configured or no SKUs provided");
            return;
        }

        dlog(`PriceLookup: Fetching prices for ${skus.length} SKUs: ${skus.join(", ")}`);

        return new Promise((resolve, reject) => {
            try {
                dlog("PriceLookup: Calling priceEndpointCallback with", skus.length, "SKUs");
                this.priceEndpointCallback(skus, (response) => {
                    // dlog(`PriceLookup: response exists? ${!!response}`);
                    // dlog(`PriceLookup: response.productData exists? ${!!(response && response.productData)}`);
                    // dlog(`PriceLookup: response.productData is array? ${!!(response && response.productData && Array.isArray(response.productData))}`);

                    if (!response || !response.productData || !Array.isArray(response.productData)) {
                        console.error("PriceLookup: Invalid product data received");
                        resolve();
                        return;
                    }

                    const productData = response.productData;
                    dlog(`PriceLookup: Received ${productData.length} product data items`);

                    productData.forEach(item => {
                        if (item.productId && typeof item.price === "number") {
                            this.priceMap.set(item.productId, item.price);
                            dlog(`PriceLookup: ${item.productId} -> $${item.price}`);
                        }
                    });

                    dlog(`PriceLookup: Loaded ${this.priceMap.size} total prices`);
                    notificationCenter.post(Notifications.pricingDidChange);
                    resolve();
                });
            } catch (error) {
                console.error("PriceLookup: Error fetching prices:", error);
                reject(error);
            }
        });
    }

    getPrice(sku, fallbackPrice = null) {
        if (this.priceMap.has(sku)) {
            return this.priceMap.get(sku);
        }
        return fallbackPrice;
    }

    clear() {
        this.priceMap.clear();
    }
}

export const priceLookup = new PriceLookup();

export function formatPrice(price) {
    if (price == null || price === 0) {
        return "";
    }

    if (Number.isInteger(price)) {
        return `$${price}`;
    } else {
        return `$${price.toFixed(2)}`;
    }
}
